module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 0
// module chunks = 0 1